import React from 'react';
import { FadeIn } from './FadeIn';
import { useLanguage } from './LanguageContext';
function CurvedRoofIcon() {
  // Isometric 3D curved roof without structure - just sheet metal curving
  const fl = {
    x: 15,
    y: 115
  };
  const fr = {
    x: 115,
    y: 115
  };
  const bl = {
    x: 55,
    y: 88
  };
  const br = {
    x: 155,
    y: 88
  };
  return <svg viewBox="0 0 200 140" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-233">
      <defs data-id="element-234">
        <linearGradient id="crSheet1" x1="15" y1="30" x2="155" y2="115" gradientUnits="userSpaceOnUse" data-id="element-235">
          <stop stopColor="#4a90d9" stopOpacity="0.3" data-id="element-236" />
          <stop offset="1" stopColor="#1e355c" stopOpacity="0.1" data-id="element-237" />
        </linearGradient>
        <linearGradient id="crEdge" x1="0" y1="0" x2="200" y2="140" gradientUnits="userSpaceOnUse" data-id="element-238">
          <stop stopColor="#d4850a" data-id="element-239" />
          <stop offset="1" stopColor="#4a90d9" data-id="element-240" />
        </linearGradient>
      </defs>

      {/* Ground shadow */}
      <ellipse cx="90" cy="120" rx="75" ry="10" fill="#2a4a7f" fillOpacity="0.1" data-id="element-241" />

      {/* Back wall */}
      <path d={`M${bl.x} ${bl.y} L${bl.x} ${bl.y - 45} Q${(bl.x + br.x) / 2} ${bl.y - 75} ${br.x} ${br.y - 45} L${br.x} ${br.y} Z`} fill="#1e355c" fillOpacity="0.15" stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.2" data-id="element-242" />

      {/* Curved roof surface - back to front */}
      {[0, 0.2, 0.4, 0.6, 0.8, 1].map((t, i) => {
      const lx = fl.x + (bl.x - fl.x) * t;
      const ly = fl.y + (bl.y - fl.y) * t;
      const rx = fr.x + (br.x - fr.x) * t;
      const ry = fr.y + (br.y - fr.y) * t;
      const peakY = ly - 50 - t * 5;
      return <path key={`arc${i}`} d={`M${lx} ${ly} L${lx} ${ly - 45 + t * 2} Q${(lx + rx) / 2} ${peakY} ${rx} ${ry - 45 + t * 2} L${rx} ${ry}`} fill="none" stroke="#4a90d9" strokeWidth={i === 5 ? 2 : 0.8} strokeOpacity={0.15 + t * 0.25} data-id="element-243" />;
    })}

      {/* Main curved roof surface fill */}
      <path d={`M${fl.x} ${fl.y} L${fl.x} ${fl.y - 45} Q${(fl.x + fr.x) / 2} ${fl.y - 75} ${fr.x} ${fr.y - 45} L${fr.x} ${fr.y} Z`} fill="url(#crSheet1)" data-id="element-244" />

      {/* Front curved arch - prominent */}
      <path d={`M${fl.x} ${fl.y - 45} Q${(fl.x + fr.x) / 2} ${fl.y - 78} ${fr.x} ${fr.y - 45}`} fill="none" stroke="#d4850a" strokeWidth="3" data-id="element-245" />

      {/* Sheet metal ribs on roof surface */}
      {[0.15, 0.3, 0.45, 0.6, 0.75, 0.85].map((t, i) => {
      const fx = fl.x + (fr.x - fl.x) * t;
      const fy = fl.y;
      const bx = bl.x + (br.x - bl.x) * t;
      const by = bl.y;
      const curveAmt = Math.sin(t * Math.PI) * 33;
      const fTopY = fy - 45 - curveAmt;
      const bTopY = by - 45 - curveAmt * 0.85;
      return <g key={`rib${i}`} data-id="element-246">
            <line x1={fx} y1={fTopY} x2={bx} y2={bTopY} stroke="#4a90d9" strokeWidth="0.8" strokeOpacity="0.3" data-id="element-247" />
            <line x1={fx} y1={fy} x2={fx} y2={fTopY} stroke="#4a90d9" strokeWidth="0.6" strokeOpacity="0.15" data-id="element-248" />
          </g>;
    })}

      {/* Front columns/walls */}
      <line x1={fl.x} y1={fl.y} x2={fl.x} y2={fl.y - 45} stroke="#4a90d9" strokeWidth="3" data-id="element-249" />
      <line x1={fr.x} y1={fr.y} x2={fr.x} y2={fr.y - 45} stroke="#4a90d9" strokeWidth="3" data-id="element-250" />

      {/* Side depth lines */}
      <line x1={fl.x} y1={fl.y} x2={bl.x} y2={bl.y} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-251" />
      <line x1={fr.x} y1={fr.y} x2={br.x} y2={br.y} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-252" />
      <line x1={fl.x} y1={fl.y - 45} x2={bl.x} y2={bl.y - 45} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.25" data-id="element-253" />
      <line x1={fr.x} y1={fr.y - 45} x2={br.x} y2={br.y - 45} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.25" data-id="element-254" />

      {/* Base line front */}
      <line x1={fl.x} y1={fl.y} x2={fr.x} y2={fr.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.4" data-id="element-255" />

      {/* Joint highlights */}
      {[{
      x: fl.x,
      y: fl.y - 45
    }, {
      x: fr.x,
      y: fr.y - 45
    }, {
      x: (fl.x + fr.x) / 2,
      y: fl.y - 78
    }].map((pt, i) => <circle key={`j${i}`} cx={pt.x} cy={pt.y} r="3" fill="#d4850a" fillOpacity="0.8" data-id="element-256" />)}

      {/* Foundation plates */}
      <rect x={fl.x - 5} y={fl.y - 1} width="10" height="3" fill="#4a90d9" fillOpacity="0.5" rx="1" data-id="element-257" />
      <rect x={fr.x - 5} y={fr.y - 1} width="10" height="3" fill="#4a90d9" fillOpacity="0.5" rx="1" data-id="element-258" />
    </svg>;
}
function SelfSupportIcon() {
  // Isometric 3D self-supporting curved roof - no columns, the curve itself holds
  const fl = {
    x: 10,
    y: 118
  };
  const fr = {
    x: 120,
    y: 118
  };
  const bl = {
    x: 55,
    y: 90
  };
  const br = {
    x: 165,
    y: 90
  };
  return <svg viewBox="0 0 200 140" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-259">
      <defs data-id="element-260">
        <linearGradient id="ssSheet" x1="10" y1="20" x2="165" y2="118" gradientUnits="userSpaceOnUse" data-id="element-261">
          <stop stopColor="#4a90d9" stopOpacity="0.25" data-id="element-262" />
          <stop offset="0.5" stopColor="#3b63a8" stopOpacity="0.15" data-id="element-263" />
          <stop offset="1" stopColor="#1e355c" stopOpacity="0.08" data-id="element-264" />
        </linearGradient>
        <linearGradient id="ssHighlight" x1="60" y1="20" x2="60" y2="118" gradientUnits="userSpaceOnUse" data-id="element-265">
          <stop stopColor="#d4850a" stopOpacity="0.15" data-id="element-266" />
          <stop offset="1" stopColor="#d4850a" stopOpacity="0" data-id="element-267" />
        </linearGradient>
      </defs>

      {/* Ground shadow */}
      <ellipse cx="90" cy="122" rx="80" ry="10" fill="#2a4a7f" fillOpacity="0.1" data-id="element-268" />

      {/* Back arch */}
      <path d={`M${bl.x} ${bl.y} Q${(bl.x + br.x) / 2} ${bl.y - 65} ${br.x} ${br.y}`} fill="none" stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.3" data-id="element-269" />

      {/* Roof surface - multiple arched ribs from back to front */}
      {[0, 0.15, 0.3, 0.45, 0.6, 0.75, 0.9, 1].map((t, i) => {
      const lx = fl.x + (bl.x - fl.x) * t;
      const ly = fl.y + (bl.y - fl.y) * t;
      const rx = fr.x + (br.x - fr.x) * t;
      const ry = fr.y + (br.y - fr.y) * t;
      const peakDepth = 65 + (1 - t) * 5;
      return <path key={`rib${i}`} d={`M${lx} ${ly} Q${(lx + rx) / 2} ${ly - peakDepth} ${rx} ${ry}`} fill="none" stroke="#4a90d9" strokeWidth={i === 7 ? 2.5 : 1} strokeOpacity={0.12 + t * 0.3} data-id="element-270" />;
    })}

      {/* Roof surface fill - front arch */}
      <path d={`M${fl.x} ${fl.y} Q${(fl.x + fr.x) / 2} ${fl.y - 70} ${fr.x} ${fr.y}`} fill="url(#ssSheet)" data-id="element-271" />
      <path d={`M${fl.x} ${fl.y} Q${(fl.x + fr.x) / 2} ${fl.y - 70} ${fr.x} ${fr.y}`} fill="url(#ssHighlight)" data-id="element-272" />

      {/* Longitudinal sheet lines connecting front to back */}
      {[0.2, 0.35, 0.5, 0.65, 0.8].map((t, i) => {
      const fCurve = Math.sin(t * Math.PI) * 70;
      const bCurve = Math.sin(t * Math.PI) * 65;
      const fx = fl.x + (fr.x - fl.x) * t;
      const fy = fl.y - fCurve;
      const bx = bl.x + (br.x - bl.x) * t;
      const by = bl.y - bCurve;
      return <line key={`long${i}`} x1={fx} y1={fy} x2={bx} y2={by} stroke="#4a90d9" strokeWidth="0.7" strokeOpacity="0.25" data-id="element-273" />;
    })}

      {/* Front arch - main outline */}
      <path d={`M${fl.x} ${fl.y} Q${(fl.x + fr.x) / 2} ${fl.y - 72} ${fr.x} ${fr.y}`} fill="none" stroke="#d4850a" strokeWidth="3" data-id="element-274" />

      {/* Side depth lines at base */}
      <line x1={fl.x} y1={fl.y} x2={bl.x} y2={bl.y} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-275" />
      <line x1={fr.x} y1={fr.y} x2={br.x} y2={br.y} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-276" />

      {/* Base line */}
      <line x1={fl.x} y1={fl.y} x2={fr.x} y2={fr.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.4" data-id="element-277" />

      {/* Peak node */}
      <circle cx={(fl.x + fr.x) / 2} cy={fl.y - 72} r="4" fill="#d4850a" data-id="element-278" />
      <circle cx={(fl.x + fr.x) / 2} cy={fl.y - 72} r="7" fill="none" stroke="#d4850a" strokeWidth="1" strokeOpacity="0.3" data-id="element-279" />

      {/* Base anchor points */}
      {[fl, fr].map((pt, i) => <g key={`a${i}`} data-id="element-280">
          <circle cx={pt.x} cy={pt.y} r="3" fill="#d4850a" fillOpacity="0.7" data-id="element-281" />
          <rect x={pt.x - 6} y={pt.y} width="12" height="3" fill="#4a90d9" fillOpacity="0.4" rx="1" data-id="element-282" />
        </g>)}

      {/* Label */}
      <text x="90" y="135" textAnchor="middle" fill="#d4850a" fontSize="7" fontWeight="bold" opacity="0.5" fontFamily="monospace" data-id="element-283">
        AUTOSOPORTANTE
      </text>
    </svg>;
}
function CurvedWithStructureIcon() {
  // Isometric 3D curved roof WITH visible steel structure underneath
  const fl = {
    x: 15,
    y: 115
  };
  const fr = {
    x: 120,
    y: 115
  };
  const bl = {
    x: 58,
    y: 88
  };
  const br = {
    x: 163,
    y: 88
  };
  const archH = 55;
  return <svg viewBox="0 0 200 140" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-284">
      <defs data-id="element-285">
        <linearGradient id="cwsRoof" x1="15" y1="30" x2="163" y2="115" gradientUnits="userSpaceOnUse" data-id="element-286">
          <stop stopColor="#4a90d9" stopOpacity="0.2" data-id="element-287" />
          <stop offset="1" stopColor="#1e355c" stopOpacity="0.08" data-id="element-288" />
        </linearGradient>
      </defs>

      {/* Ground shadow */}
      <ellipse cx="95" cy="120" rx="78" ry="10" fill="#2a4a7f" fillOpacity="0.1" data-id="element-289" />

      {/* Back structure frame */}
      <line x1={bl.x} y1={bl.y} x2={bl.x} y2={bl.y - archH + 10} stroke="#4a90d9" strokeWidth="2.5" strokeOpacity="0.35" data-id="element-290" />
      <line x1={br.x} y1={br.y} x2={br.x} y2={br.y - archH + 10} stroke="#4a90d9" strokeWidth="2.5" strokeOpacity="0.35" data-id="element-291" />
      <path d={`M${bl.x} ${bl.y - archH + 10} Q${(bl.x + br.x) / 2} ${bl.y - archH - 25} ${br.x} ${br.y - archH + 10}`} fill="none" stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.3" data-id="element-292" />

      {/* Back truss arched members */}
      {[0.25, 0.5, 0.75].map((t, i) => {
      const bCurve = Math.sin(t * Math.PI) * (archH + 15);
      const bx = bl.x + (br.x - bl.x) * t;
      const by = bl.y - bCurve + 10;
      return <line key={`bt${i}`} x1={bx} y1={bl.y} x2={bx} y2={by} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.2" data-id="element-293" />;
    })}

      {/* Depth connecting lines (purlins) */}
      {[0.2, 0.4, 0.6, 0.8].map((t, i) => {
      const fCurve = Math.sin(t * Math.PI) * (archH + 18);
      const bCurve = Math.sin(t * Math.PI) * (archH + 15);
      const fx = fl.x + (fr.x - fl.x) * t;
      const fy = fl.y - fCurve + 8;
      const bx = bl.x + (br.x - bl.x) * t;
      const by = bl.y - bCurve + 10;
      return <line key={`purlin${i}`} x1={fx} y1={fy} x2={bx} y2={by} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.25" data-id="element-294" />;
    })}

      {/* Roof surface fill */}
      <path d={`M${fl.x} ${fl.y - archH + 8} Q${(fl.x + fr.x) / 2} ${fl.y - archH - 28} ${fr.x} ${fr.y - archH + 8} L${br.x} ${br.y - archH + 10} Q${(bl.x + br.x) / 2} ${bl.y - archH - 25} ${bl.x} ${bl.y - archH + 10} Z`} fill="url(#cwsRoof)" data-id="element-295" />

      {/* Front columns - thick steel */}
      <rect x={fl.x - 3} y={fl.y - archH + 8} width="6" height={archH - 8} fill="#4a90d9" fillOpacity="0.7" rx="1" data-id="element-296" />
      <rect x={fr.x - 3} y={fr.y - archH + 8} width="6" height={archH - 8} fill="#4a90d9" fillOpacity="0.7" rx="1" data-id="element-297" />

      {/* Front arched truss - the main visible structure */}
      <path d={`M${fl.x} ${fl.y - archH + 8} Q${(fl.x + fr.x) / 2} ${fl.y - archH - 28} ${fr.x} ${fr.y - archH + 8}`} fill="none" stroke="#d4850a" strokeWidth="3.5" data-id="element-298" />

      {/* Inner truss chord */}
      <path d={`M${fl.x + 5} ${fl.y - archH + 18} Q${(fl.x + fr.x) / 2} ${fl.y - archH - 15} ${fr.x - 5} ${fr.y - archH + 18}`} fill="none" stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.5" data-id="element-299" />

      {/* Truss web members (diagonal connections between chords) */}
      {[0.15, 0.3, 0.45, 0.55, 0.7, 0.85].map((t, i) => {
      const outerCurve = Math.sin(t * Math.PI) * (archH + 18);
      const innerCurve = Math.sin(t * Math.PI) * (archH + 5);
      const x = fl.x + (fr.x - fl.x) * t;
      const outerY = fl.y - outerCurve + 8;
      const innerY = fl.y - innerCurve + 18;
      return <g key={`web${i}`} data-id="element-300">
            <line x1={x} y1={outerY} x2={x} y2={innerY} stroke="#4a90d9" strokeWidth="1.2" strokeOpacity="0.45" data-id="element-301" />
            <circle cx={x} cy={outerY} r="2" fill="#d4850a" fillOpacity="0.6" data-id="element-302" />
          </g>;
    })}

      {/* Front vertical truss members */}
      {[0.25, 0.5, 0.75].map((t, i) => {
      const curve = Math.sin(t * Math.PI) * (archH + 18);
      const x = fl.x + (fr.x - fl.x) * t;
      const topY = fl.y - curve + 8;
      return <line key={`vert${i}`} x1={x} y1={fl.y} x2={x} y2={topY} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-303" />;
    })}

      {/* Side depth lines */}
      <line x1={fl.x} y1={fl.y} x2={bl.x} y2={bl.y} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-304" />
      <line x1={fr.x} y1={fr.y} x2={br.x} y2={br.y} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-305" />

      {/* Base line */}
      <line x1={fl.x} y1={fl.y} x2={fr.x} y2={fr.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.4" data-id="element-306" />

      {/* Joint highlights */}
      {[{
      x: fl.x,
      y: fl.y - archH + 8
    }, {
      x: fr.x,
      y: fr.y - archH + 8
    }, {
      x: (fl.x + fr.x) / 2,
      y: fl.y - archH - 28
    }].map((pt, i) => <g key={`jt${i}`} data-id="element-307">
          <circle cx={pt.x} cy={pt.y} r="4" fill="#d4850a" data-id="element-308" />
          <circle cx={pt.x} cy={pt.y} r="7" fill="none" stroke="#d4850a" strokeWidth="1" strokeOpacity="0.3" data-id="element-309" />
        </g>)}

      {/* Foundation plates */}
      {[fl, fr].map((pt, i) => <rect key={`fp${i}`} x={pt.x - 6} y={pt.y - 1} width="12" height="4" fill="#4a90d9" fillOpacity="0.5" rx="1" data-id="element-310" />)}
    </svg>;
}
function TwoSlopeIcon() {
  // Isometric 3D two-slope (a dos aguas) roof with visible structure
  const fl = {
    x: 20,
    y: 115
  };
  const fr = {
    x: 125,
    y: 115
  };
  const bl = {
    x: 60,
    y: 88
  };
  const br = {
    x: 165,
    y: 88
  };
  const colH = 45;
  const flt = {
    x: fl.x,
    y: fl.y - colH
  };
  const frt = {
    x: fr.x,
    y: fr.y - colH
  };
  const blt = {
    x: bl.x,
    y: bl.y - colH
  };
  const brt = {
    x: br.x,
    y: br.y - colH
  };
  const ridgeF = {
    x: (fl.x + fr.x) / 2,
    y: flt.y - 28
  };
  const ridgeB = {
    x: (bl.x + br.x) / 2,
    y: blt.y - 28
  };
  return <svg viewBox="0 0 200 140" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-311">
      <defs data-id="element-312">
        <linearGradient id="ts3dRoof1" x1="20" y1="20" x2="112" y2="88" gradientUnits="userSpaceOnUse" data-id="element-313">
          <stop stopColor="#4a90d9" stopOpacity="0.25" data-id="element-314" />
          <stop offset="1" stopColor="#1e355c" stopOpacity="0.08" data-id="element-315" />
        </linearGradient>
        <linearGradient id="ts3dRoof2" x1="72" y1="20" x2="165" y2="88" gradientUnits="userSpaceOnUse" data-id="element-316">
          <stop stopColor="#3b63a8" stopOpacity="0.18" data-id="element-317" />
          <stop offset="1" stopColor="#1e355c" stopOpacity="0.05" data-id="element-318" />
        </linearGradient>
      </defs>

      {/* Ground shadow */}
      <ellipse cx="95" cy="120" rx="78" ry="10" fill="#2a4a7f" fillOpacity="0.1" data-id="element-319" />

      {/* Back columns */}
      <line x1={bl.x} y1={bl.y} x2={blt.x} y2={blt.y} stroke="#4a90d9" strokeWidth="3" strokeOpacity="0.35" data-id="element-320" />
      <line x1={br.x} y1={br.y} x2={brt.x} y2={brt.y} stroke="#4a90d9" strokeWidth="3" strokeOpacity="0.35" data-id="element-321" />

      {/* Back top beam */}
      <line x1={blt.x} y1={blt.y} x2={brt.x} y2={brt.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.3" data-id="element-322" />

      {/* Back roof lines */}
      <line x1={blt.x} y1={blt.y} x2={ridgeB.x} y2={ridgeB.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.3" data-id="element-323" />
      <line x1={brt.x} y1={brt.y} x2={ridgeB.x} y2={ridgeB.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.3" data-id="element-324" />

      {/* Left roof surface */}
      <polygon points={`${flt.x},${flt.y} ${ridgeF.x},${ridgeF.y} ${ridgeB.x},${ridgeB.y} ${blt.x},${blt.y}`} fill="url(#ts3dRoof1)" data-id="element-325" />
      {/* Right roof surface */}
      <polygon points={`${frt.x},${frt.y} ${ridgeF.x},${ridgeF.y} ${ridgeB.x},${ridgeB.y} ${brt.x},${brt.y}`} fill="url(#ts3dRoof2)" data-id="element-326" />

      {/* Ridge beam - prominent */}
      <line x1={ridgeF.x} y1={ridgeF.y} x2={ridgeB.x} y2={ridgeB.y} stroke="#d4850a" strokeWidth="3" data-id="element-327" />

      {/* Roof purlins - left slope */}
      {[0.3, 0.6].map((t, i) => {
      const fx = flt.x + (ridgeF.x - flt.x) * t;
      const fy = flt.y + (ridgeF.y - flt.y) * t;
      const bx = blt.x + (ridgeB.x - blt.x) * t;
      const by = blt.y + (ridgeB.y - blt.y) * t;
      return <line key={`lp${i}`} x1={fx} y1={fy} x2={bx} y2={by} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.25" data-id="element-328" />;
    })}
      {/* Roof purlins - right slope */}
      {[0.3, 0.6].map((t, i) => {
      const fx = frt.x + (ridgeF.x - frt.x) * t;
      const fy = frt.y + (ridgeF.y - frt.y) * t;
      const bx = brt.x + (ridgeB.x - brt.x) * t;
      const by = brt.y + (ridgeB.y - brt.y) * t;
      return <line key={`rp${i}`} x1={fx} y1={fy} x2={bx} y2={by} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.25" data-id="element-329" />;
    })}

      {/* Side depth lines */}
      <line x1={flt.x} y1={flt.y} x2={blt.x} y2={blt.y} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-330" />
      <line x1={frt.x} y1={frt.y} x2={brt.x} y2={brt.y} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-331" />
      <line x1={fl.x} y1={fl.y} x2={bl.x} y2={bl.y} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.2" data-id="element-332" />
      <line x1={fr.x} y1={fr.y} x2={br.x} y2={br.y} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.2" data-id="element-333" />

      {/* Front columns */}
      <rect x={fl.x - 3} y={flt.y} width="6" height={colH} fill="#4a90d9" fillOpacity="0.7" rx="1" data-id="element-334" />
      <rect x={fr.x - 3} y={frt.y} width="6" height={colH} fill="#4a90d9" fillOpacity="0.7" rx="1" data-id="element-335" />

      {/* Front top beam */}
      <line x1={flt.x} y1={flt.y} x2={frt.x} y2={frt.y} stroke="#4a90d9" strokeWidth="3" data-id="element-336" />

      {/* Front truss - left rafter */}
      <line x1={flt.x} y1={flt.y} x2={ridgeF.x} y2={ridgeF.y} stroke="#d4850a" strokeWidth="3" data-id="element-337" />
      {/* Front truss - right rafter */}
      <line x1={frt.x} y1={frt.y} x2={ridgeF.x} y2={ridgeF.y} stroke="#d4850a" strokeWidth="3" data-id="element-338" />

      {/* Front truss web members - left */}
      {[0.25, 0.5, 0.75].map((t, i) => {
      const x = flt.x + (ridgeF.x - flt.x) * t;
      const y = flt.y + (ridgeF.y - flt.y) * t;
      return <line key={`twl${i}`} x1={x} y1={y} x2={x} y2={flt.y} stroke="#4a90d9" strokeWidth="1.2" strokeOpacity="0.4" data-id="element-339" />;
    })}
      {/* Front truss web members - right */}
      {[0.25, 0.5, 0.75].map((t, i) => {
      const x = frt.x + (ridgeF.x - frt.x) * t;
      const y = frt.y + (ridgeF.y - frt.y) * t;
      return <line key={`twr${i}`} x1={x} y1={y} x2={x} y2={frt.y} stroke="#4a90d9" strokeWidth="1.2" strokeOpacity="0.4" data-id="element-340" />;
    })}

      {/* Front cross-bracing */}
      <line x1={fl.x} y1={fl.y} x2={frt.x} y2={frt.y} stroke="#4a90d9" strokeWidth="0.8" strokeOpacity="0.2" data-id="element-341" />
      <line x1={fr.x} y1={fr.y} x2={flt.x} y2={flt.y} stroke="#4a90d9" strokeWidth="0.8" strokeOpacity="0.2" data-id="element-342" />

      {/* Base line */}
      <line x1={fl.x} y1={fl.y} x2={fr.x} y2={fr.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.4" data-id="element-343" />

      {/* Joint highlights */}
      {[{
      x: flt.x,
      y: flt.y,
      s: 1
    }, {
      x: frt.x,
      y: frt.y,
      s: 1
    }, {
      x: ridgeF.x,
      y: ridgeF.y,
      s: 1.2
    }, {
      x: blt.x,
      y: blt.y,
      s: 0.6
    }, {
      x: brt.x,
      y: brt.y,
      s: 0.6
    }, {
      x: ridgeB.x,
      y: ridgeB.y,
      s: 0.6
    }].map((pt, i) => <g key={`gp${i}`} data-id="element-344">
          <circle cx={pt.x} cy={pt.y} r={3.5 * pt.s} fill="#d4850a" fillOpacity={pt.s > 0.8 ? 0.9 : 0.4} data-id="element-345" />
          <circle cx={pt.x} cy={pt.y} r={6 * pt.s} fill="none" stroke="#d4850a" strokeWidth="0.8" strokeOpacity={pt.s > 0.8 ? 0.35 : 0.15} data-id="element-346" />
        </g>)}

      {/* Foundation plates */}
      {[fl, fr].map((pt, i) => <rect key={`fp${i}`} x={pt.x - 6} y={pt.y - 1} width="12" height="4" fill="#4a90d9" fillOpacity="0.5" rx="1" data-id="element-347" />)}
    </svg>;
}
function StructureIcon() {
  // Isometric 3D steel frame warehouse structure
  // Front-left, front-right, back-left, back-right base points
  const fl = {
    x: 30,
    y: 110
  };
  const fr = {
    x: 130,
    y: 110
  };
  const bl = {
    x: 70,
    y: 85
  };
  const br = {
    x: 170,
    y: 85
  };
  // Top points (columns go up)
  const colH = 50;
  const flt = {
    x: fl.x,
    y: fl.y - colH
  };
  const frt = {
    x: fr.x,
    y: fr.y - colH
  };
  const blt = {
    x: bl.x,
    y: bl.y - colH
  };
  const brt = {
    x: br.x,
    y: br.y - colH
  };
  // Ridge points (roof peak)
  const ridgeF = {
    x: (fl.x + fr.x) / 2,
    y: flt.y - 25
  };
  const ridgeB = {
    x: (bl.x + br.x) / 2,
    y: blt.y - 25
  };
  return <svg viewBox="0 0 200 140" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-348">
      <defs data-id="element-349">
        <linearGradient id="stGrad" x1="0" y1="0" x2="200" y2="140" gradientUnits="userSpaceOnUse" data-id="element-350">
          <stop stopColor="#4a90d9" data-id="element-351" />
          <stop offset="1" stopColor="#1e355c" data-id="element-352" />
        </linearGradient>
        <linearGradient id="stRoof1" x1="30" y1="35" x2="120" y2="85" gradientUnits="userSpaceOnUse" data-id="element-353">
          <stop stopColor="#4a90d9" stopOpacity="0.2" data-id="element-354" />
          <stop offset="1" stopColor="#1e355c" stopOpacity="0.08" data-id="element-355" />
        </linearGradient>
        <linearGradient id="stRoof2" x1="80" y1="35" x2="170" y2="85" gradientUnits="userSpaceOnUse" data-id="element-356">
          <stop stopColor="#3b63a8" stopOpacity="0.15" data-id="element-357" />
          <stop offset="1" stopColor="#1e355c" stopOpacity="0.05" data-id="element-358" />
        </linearGradient>
      </defs>

      {/* Ground shadow */}
      <ellipse cx="100" cy="118" rx="85" ry="10" fill="#2a4a7f" fillOpacity="0.1" data-id="element-359" />

      {/* Ground/foundation lines */}
      <line x1={fl.x} y1={fl.y} x2={fr.x} y2={fr.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.3" data-id="element-360" />
      <line x1={fr.x} y1={fr.y} x2={br.x} y2={br.y} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.2" data-id="element-361" />
      <line x1={fl.x} y1={fl.y} x2={bl.x} y2={bl.y} stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.2" data-id="element-362" />

      {/* Back columns */}
      <line x1={bl.x} y1={bl.y} x2={blt.x} y2={blt.y} stroke="#4a90d9" strokeWidth="3" strokeOpacity="0.4" data-id="element-363" />
      <line x1={br.x} y1={br.y} x2={brt.x} y2={brt.y} stroke="#4a90d9" strokeWidth="3" strokeOpacity="0.4" data-id="element-364" />

      {/* Back top beam */}
      <line x1={blt.x} y1={blt.y} x2={brt.x} y2={brt.y} stroke="#4a90d9" strokeWidth="2.5" strokeOpacity="0.35" data-id="element-365" />

      {/* Back roof lines */}
      <line x1={blt.x} y1={blt.y} x2={ridgeB.x} y2={ridgeB.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.3" data-id="element-366" />
      <line x1={brt.x} y1={brt.y} x2={ridgeB.x} y2={ridgeB.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.3" data-id="element-367" />

      {/* Back cross-bracing */}
      <line x1={bl.x} y1={bl.y} x2={brt.x} y2={brt.y} stroke="#4a90d9" strokeWidth="0.8" strokeOpacity="0.2" strokeDasharray="3 2" data-id="element-368" />
      <line x1={br.x} y1={br.y} x2={blt.x} y2={blt.y} stroke="#4a90d9" strokeWidth="0.8" strokeOpacity="0.2" strokeDasharray="3 2" data-id="element-369" />

      {/* Side panels (depth lines connecting front to back) */}
      <line x1={flt.x} y1={flt.y} x2={blt.x} y2={blt.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.35" data-id="element-370" />
      <line x1={frt.x} y1={frt.y} x2={brt.x} y2={brt.y} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.35" data-id="element-371" />
      <line x1={ridgeF.x} y1={ridgeF.y} x2={ridgeB.x} y2={ridgeB.y} stroke="#d4850a" strokeWidth="2.5" data-id="element-372" />

      {/* Roof fill - left slope */}
      <polygon points={`${flt.x},${flt.y} ${ridgeF.x},${ridgeF.y} ${ridgeB.x},${ridgeB.y} ${blt.x},${blt.y}`} fill="url(#stRoof1)" data-id="element-373" />
      {/* Roof fill - right slope */}
      <polygon points={`${frt.x},${frt.y} ${ridgeF.x},${ridgeF.y} ${ridgeB.x},${ridgeB.y} ${brt.x},${brt.y}`} fill="url(#stRoof2)" data-id="element-374" />

      {/* Roof purlins (horizontal lines on roof) */}
      {[0.33, 0.66].map((t, i) => {
      const lx = flt.x + (ridgeF.x - flt.x) * t;
      const ly = flt.y + (ridgeF.y - flt.y) * t;
      const rx = blt.x + (ridgeB.x - blt.x) * t;
      const ry = blt.y + (ridgeB.y - blt.y) * t;
      return <line key={`pl${i}`} x1={lx} y1={ly} x2={rx} y2={ry} stroke="#4a90d9" strokeWidth="0.8" strokeOpacity="0.25" data-id="element-375" />;
    })}
      {[0.33, 0.66].map((t, i) => {
      const lx = frt.x + (ridgeF.x - frt.x) * t;
      const ly = frt.y + (ridgeF.y - frt.y) * t;
      const rx = brt.x + (ridgeB.x - brt.x) * t;
      const ry = brt.y + (ridgeB.y - brt.y) * t;
      return <line key={`pr${i}`} x1={lx} y1={ly} x2={rx} y2={ry} stroke="#4a90d9" strokeWidth="0.8" strokeOpacity="0.25" data-id="element-376" />;
    })}

      {/* Front columns (on top - more prominent) */}
      <line x1={fl.x} y1={fl.y} x2={flt.x} y2={flt.y} stroke="#4a90d9" strokeWidth="4" data-id="element-377" />
      <line x1={fr.x} y1={fr.y} x2={frt.x} y2={frt.y} stroke="#4a90d9" strokeWidth="4" data-id="element-378" />

      {/* Front top beam */}
      <line x1={flt.x} y1={flt.y} x2={frt.x} y2={frt.y} stroke="#4a90d9" strokeWidth="3" data-id="element-379" />

      {/* Front mid beam */}
      <line x1={fl.x + 0} y1={flt.y + 25} x2={fr.x} y2={frt.y + 25} stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.5" data-id="element-380" />

      {/* Front cross-bracing */}
      <line x1={fl.x} y1={fl.y} x2={frt.x} y2={frt.y} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.25" data-id="element-381" />
      <line x1={fr.x} y1={fr.y} x2={flt.x} y2={flt.y} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.25" data-id="element-382" />

      {/* Front roof truss */}
      <line x1={flt.x} y1={flt.y} x2={ridgeF.x} y2={ridgeF.y} stroke="#d4850a" strokeWidth="3" data-id="element-383" />
      <line x1={frt.x} y1={frt.y} x2={ridgeF.x} y2={ridgeF.y} stroke="#d4850a" strokeWidth="3" data-id="element-384" />

      {/* Truss internal web members */}
      {[0.25, 0.5, 0.75].map((t, i) => {
      const lx = flt.x + (ridgeF.x - flt.x) * t;
      const ly = flt.y + (ridgeF.y - flt.y) * t;
      return <line key={`tw${i}`} x1={lx} y1={ly} x2={lx} y2={flt.y} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.4" data-id="element-385" />;
    })}
      {[0.25, 0.5, 0.75].map((t, i) => {
      const rx = frt.x + (ridgeF.x - frt.x) * t;
      const ry = frt.y + (ridgeF.y - frt.y) * t;
      return <line key={`twr${i}`} x1={rx} y1={ry} x2={rx} y2={frt.y} stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.4" data-id="element-386" />;
    })}

      {/* Right side cross-bracing */}
      <line x1={fr.x} y1={fr.y} x2={brt.x} y2={brt.y} stroke="#4a90d9" strokeWidth="0.8" strokeOpacity="0.2" strokeDasharray="3 2" data-id="element-387" />
      <line x1={frt.x} y1={frt.y} x2={br.x} y2={br.y} stroke="#4a90d9" strokeWidth="0.8" strokeOpacity="0.2" strokeDasharray="3 2" data-id="element-388" />

      {/* Gusset plate highlights at joints */}
      {[{
      x: flt.x,
      y: flt.y
    }, {
      x: frt.x,
      y: frt.y
    }, {
      x: ridgeF.x,
      y: ridgeF.y
    }, {
      x: blt.x,
      y: blt.y
    }, {
      x: brt.x,
      y: brt.y
    }, {
      x: ridgeB.x,
      y: ridgeB.y
    }].map((pt, i) => <g key={`gp${i}`} data-id="element-389">
          <circle cx={pt.x} cy={pt.y} r="3.5" fill="#d4850a" fillOpacity={i < 3 ? 0.9 : 0.4} data-id="element-390" />
          <circle cx={pt.x} cy={pt.y} r="6" fill="none" stroke="#d4850a" strokeWidth="0.8" strokeOpacity={i < 3 ? 0.4 : 0.15} data-id="element-391" />
        </g>)}

      {/* Foundation plates */}
      {[fl, fr, bl, br].map((pt, i) => <rect key={`fp${i}`} x={pt.x - 6} y={pt.y - 1} width="12" height="4" fill="#4a90d9" fillOpacity={i < 2 ? 0.6 : 0.3} rx="1" data-id="element-392" />)}
    </svg>;
}
function HerreriaIcon() {
  return <svg viewBox="0 0 200 140" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-393">
      <defs data-id="element-394">
        <linearGradient id="hrGrad" x1="0" y1="0" x2="200" y2="140" gradientUnits="userSpaceOnUse" data-id="element-395">
          <stop stopColor="#4a90d9" data-id="element-396" />
          <stop offset="1" stopColor="#1e355c" data-id="element-397" />
        </linearGradient>
      </defs>
      <rect x="0" y="125" width="200" height="15" fill="#2a4a7f" fillOpacity="0.15" rx="2" data-id="element-398" />
      <rect x="15" y="15" width="80" height="110" rx="4" fill="url(#hrGrad)" fillOpacity="0.08" stroke="#4a90d9" strokeWidth="2.5" data-id="element-399" />
      <rect x="20" y="20" width="70" height="100" rx="2" fill="none" stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.3" data-id="element-400" />
      <circle cx="80" cy="70" r="4" fill="#d4850a" data-id="element-401" />
      <line x1="55" y1="20" x2="55" y2="120" stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.3" data-id="element-402" />
      <line x1="20" y1="70" x2="90" y2="70" stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.3" data-id="element-403" />
      <rect x="120" y="80" width="65" height="45" rx="2" fill="none" stroke="#4a90d9" strokeWidth="2" data-id="element-404" />
      <line x1="120" y1="80" x2="185" y2="80" stroke="#d4850a" strokeWidth="3" data-id="element-405" />
      <line x1="120" y1="80" x2="120" y2="125" stroke="#4a90d9" strokeWidth="3" data-id="element-406" />
      <line x1="185" y1="80" x2="185" y2="125" stroke="#4a90d9" strokeWidth="3" data-id="element-407" />
      {[132, 145, 158, 172].map((x, i) => <line key={i} x1={x} y1="80" x2={x} y2="125" stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.4" data-id="element-408" />)}
      <path d="M130 30 Q152 15 175 30" fill="none" stroke="#d4850a" strokeWidth="2" data-id="element-409" />
      <path d="M135 38 Q152 25 170 38" fill="none" stroke="#4a90d9" strokeWidth="1.5" strokeOpacity="0.5" data-id="element-410" />
      <line x1="130" y1="30" x2="130" y2="55" stroke="#4a90d9" strokeWidth="2" data-id="element-411" />
      <line x1="175" y1="30" x2="175" y2="55" stroke="#4a90d9" strokeWidth="2" data-id="element-412" />
      <line x1="128" y1="55" x2="177" y2="55" stroke="#4a90d9" strokeWidth="2" data-id="element-413" />
    </svg>;
}
function DomeIcon() {
  // Generate geodesic triangular facets
  const cx = 100;
  const baseY = 115;
  const topY = 12;
  const baseR = 82;
  // Dome profile: given an angle from center, get the y and radius at that height
  const levels = [{
    y: 105,
    r: 80
  }, {
    y: 85,
    r: 74
  }, {
    y: 65,
    r: 62
  }, {
    y: 45,
    r: 44
  }, {
    y: 28,
    r: 22
  }, {
    y: topY,
    r: 0
  }];
  // Generate points on each ring
  const rings = levels.map(level => {
    const count = level.r === 0 ? 1 : 8;
    const pts = [];
    for (let i = 0; i < count; i++) {
      const angle = i / count * Math.PI + (level.y % 2 === 1 ? Math.PI / count : 0);
      const x = cx + level.r * Math.cos(angle);
      pts.push({
        x,
        y: level.y
      });
    }
    return pts;
  });
  // Build triangle paths between adjacent rings
  const triangles: Array<{
    points: string;
    opacity: number;
  }> = [];
  for (let r = 0; r < rings.length - 1; r++) {
    const upper = rings[r + 1];
    const lower = rings[r];
    if (upper.length === 1) {
      // Connect to apex
      for (let i = 0; i < lower.length; i++) {
        const a = lower[i];
        const b = lower[(i + 1) % lower.length];
        const c = upper[0];
        triangles.push({
          points: `${a.x},${a.y} ${b.x},${b.y} ${c.x},${c.y}`,
          opacity: 0.12 + r * 0.04
        });
      }
    } else {
      for (let i = 0; i < lower.length; i++) {
        const a = lower[i];
        const b = lower[(i + 1) % lower.length];
        const c = upper[i % upper.length];
        const d = upper[(i + 1) % upper.length];
        // Two triangles per quad
        triangles.push({
          points: `${a.x},${a.y} ${b.x},${b.y} ${c.x},${c.y}`,
          opacity: 0.08 + r * 0.03
        });
        triangles.push({
          points: `${b.x},${b.y} ${d.x},${d.y} ${c.x},${c.y}`,
          opacity: 0.06 + r * 0.03
        });
      }
    }
  }
  return <svg viewBox="0 0 200 140" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-414">
      <defs data-id="element-415">
        <radialGradient id="domeGrad2" cx="90" cy="50" r="90" gradientUnits="userSpaceOnUse" data-id="element-416">
          <stop stopColor="#4a90d9" stopOpacity="0.35" data-id="element-417" />
          <stop offset="0.7" stopColor="#1e355c" stopOpacity="0.1" data-id="element-418" />
          <stop offset="1" stopColor="#0a1628" stopOpacity="0.05" data-id="element-419" />
        </radialGradient>
        <linearGradient id="domeEdge" x1="20" y1="20" x2="180" y2="115" gradientUnits="userSpaceOnUse" data-id="element-420">
          <stop stopColor="#d4850a" data-id="element-421" />
          <stop offset="1" stopColor="#4a90d9" data-id="element-422" />
        </linearGradient>
      </defs>

      {/* Ground shadow */}
      <ellipse cx={cx} cy="120" rx="85" ry="12" fill="#2a4a7f" fillOpacity="0.12" data-id="element-423" />

      {/* Dome fill */}
      <path d="M18 115 Q18 18 100 12 Q182 18 182 115 Z" fill="url(#domeGrad2)" data-id="element-424" />

      {/* Geodesic triangular facets */}
      {triangles.map((tri, i) => <polygon key={`f${i}`} points={tri.points} fill="#4a90d9" fillOpacity={tri.opacity} stroke="#4a90d9" strokeWidth="0.8" strokeOpacity="0.35" data-id="element-425" />)}

      {/* Horizontal ring lines */}
      {levels.slice(0, -1).map((level, i) => <ellipse key={`ring${i}`} cx={cx} cy={level.y} rx={level.r} ry={3 + i * 0.5} fill="none" stroke="#4a90d9" strokeWidth="1.2" strokeOpacity={0.25 + i * 0.08} data-id="element-426" />)}

      {/* Vertical meridian lines */}
      {[0, 1, 2, 3, 4, 5, 6, 7].map(i => {
      const angle = i / 8 * Math.PI;
      const points = levels.filter(l => l.r > 0).map(l => `${cx + l.r * Math.cos(angle)},${l.y}`);
      return <polyline key={`m${i}`} points={`${cx + baseR * Math.cos(angle)},${baseY} ${points.join(' ')} ${cx},${topY}`} fill="none" stroke="#4a90d9" strokeWidth="1" strokeOpacity="0.3" data-id="element-427" />;
    })}

      {/* Dome outline */}
      <path d="M18 115 Q18 18 100 12 Q182 18 182 115" fill="none" stroke="url(#domeEdge)" strokeWidth="2.5" data-id="element-428" />

      {/* Base ellipse */}
      <ellipse cx={cx} cy="115" rx={baseR} ry="7" fill="none" stroke="#4a90d9" strokeWidth="2" strokeOpacity="0.5" data-id="element-429" />

      {/* Apex highlight */}
      <circle cx={cx} cy={topY} r="5" fill="#d4850a" data-id="element-430" />
      <circle cx={cx} cy={topY} r="8" fill="none" stroke="#d4850a" strokeWidth="1" strokeOpacity="0.3" data-id="element-431" />

      {/* Node highlights at intersections */}
      {rings.slice(0, -1).map((ring, ri) => ring.map((pt, pi) => <circle key={`n${ri}-${pi}`} cx={pt.x} cy={pt.y} r="1.5" fill="#d4850a" fillOpacity={0.4 + ri * 0.1} data-id="element-432" />))}
    </svg>;
}
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: CurvedRoofIcon,
    title: t('services.card1.title'),
    description: t('services.card1.desc')
  }, {
    icon: SelfSupportIcon,
    title: t('services.card2.title'),
    description: t('services.card2.desc')
  }, {
    icon: CurvedWithStructureIcon,
    title: t('services.card3.title'),
    description: t('services.card3.desc')
  }, {
    icon: TwoSlopeIcon,
    title: t('services.card4.title'),
    description: t('services.card4.desc')
  }, {
    icon: StructureIcon,
    title: t('services.card5.title'),
    description: t('services.card5.desc')
  }, {
    icon: HerreriaIcon,
    title: t('services.card6.title'),
    description: t('services.card6.desc')
  }, {
    icon: DomeIcon,
    title: t('services.card7.title'),
    description: t('services.card7.desc')
  }];
  return <section className="w-full bg-navy-800 py-20 sm:py-28" data-id="element-433">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-434">
        <FadeIn data-id="element-435">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-436">
            <h2 className="text-3xl sm:text-4xl font-black text-white mb-6" data-id="element-437">
              {t('services.title')}
            </h2>
            <p className="text-xl text-gray-300" data-id="element-438">{t('services.subtitle')}</p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-439">
          {services.map((service, index) => {
          const Illustration = service.icon;
          return <FadeIn key={index} delay={0.08 * (index + 1)} data-id="element-440">
                <div className="group bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 h-full flex flex-col" data-id="element-441">
                  <div className="relative h-48 bg-gradient-to-br from-navy-900 to-navy-800 p-6 flex items-center justify-center overflow-hidden" data-id="element-442">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(42,74,127,0.3),transparent_70%)]" data-id="element-443"></div>
                    <div className="relative w-full h-full group-hover:scale-105 transition-transform duration-500" data-id="element-444">
                      <Illustration data-id="element-445" />
                    </div>
                  </div>
                  <div className="p-6 flex-1 flex flex-col" data-id="element-446">
                    <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-447">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed flex-1" data-id="element-448">
                      {service.description}
                    </p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.7} data-id="element-449">
          <div className="mt-16 text-center" data-id="element-450">
            <a href="#contacto" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-lg text-navy-900 bg-amber hover:bg-amber-light transition-colors duration-300 uppercase tracking-wider shadow-lg hover:shadow-amber/30" data-id="element-451">
              Solicita tu Cotización
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}